import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { New_ScrollX2025 } from "../../assets/icons";
import Setting from "../../Pages/Setting/Setting";
import "../../assets/styles/Style.css";
import "../Navbar.css";

const Navbar = () => {
  const userInfo = JSON.parse(localStorage.getItem("user"));
  const [isSettingOpen, setIsSettingOpen] = useState(false);
  const profileBtnRef = useRef(null);

  const getUserInitials = () => {
    const firstName = userInfo?.firstName?.trim() || "";
    if (firstName) return firstName.charAt(0).toUpperCase();
    return "U";
  };

  const getBackgroundColor = () => "#7c5cff26";

  return (
    <>
      <nav className="w-full h-full Pro_navbarDash flex items-center justify-between text-slate-200">
        <div className="w-full h-full flex items-center justify-between">
          <a href="https://scrollx.io/" className="nav-logo">
            <span className="nav-logo-icon">
              <img className="logo-img999" src={New_ScrollX2025} alt="ScrollX" />
            </span>
            <span>ScrollX</span>
          </a>

          <div className="flex items-center gap-6">
            <Link to="/dashboard">
              <span className="text-white text-[15px] font-body">Dashboard</span>
            </Link>
            <Link to="/dashboard/myrenders">
              <span className="text-white text-[15px] font-body">My Renders</span>
            </Link>
          </div>

          <div className="top-actionslogin flex items-center gap-3">
            <span className="text-[13px] text-[#a8a4c8] hidden sm:block">
              {userInfo?.email}
            </span>
            <button
              ref={profileBtnRef}
              type="button"
              className="w-[35px] h-[35px] border-[1px] border-[#7c5cff4d] hover:bg-[#7c5cff40] rounded-full transition-colors"
              onClick={() => setIsSettingOpen((open) => !open)}
              style={{ backgroundColor: getBackgroundColor() }}
              aria-expanded={isSettingOpen}
              aria-haspopup="true"
            >
              <div className="flex justify-center items-center text-[#c4b2ff] text-xl font-body w-[35px] h-[35px] rounded-full">
                <span className="font-body text-[#c4b2ff] text-lg text-center">
                  {getUserInitials()}
                </span>
              </div>
            </button>
          </div>
        </div>
      </nav>

      <Setting
        isSettingOpen={isSettingOpen}
        setIsSettingOpen={setIsSettingOpen}
        anchorRef={profileBtnRef}
      />
    </>
  );
};

export default Navbar;
